<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text }}
        </v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <v-data-table :loading="loading" :headers="encabezadoAdminSuper" :items="reporteUsuario" :items-per-page="15"
          class="elevation-3" dense>
          <template v-slot:top>
            <v-form v-model="isValid">
              <v-toolbar flat>
                <!-- Formulario busqueda de venta usuario -->
                <v-toolbar-title class="hidden-sm-and-down">REPORTE USUARIO</v-toolbar-title>
                <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
                <v-spacer />
                <v-autocomplete dense @keyup="selectUsuario()" :search-input.sync="buscar_usuario" v-model="idusuario"
                  :items="usuarios" label="Nombres" :rules="[v => !!v || 'Nombres es requerido']" clearable hide-details
                  class="mr-1" @change="reporteUsuario = []" :disabled="!desabilitarBuscar"></v-autocomplete>
                <v-menu v-model="menuFecha" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field dense v-model="dateRangeText" readonly v-on="on" hide-details class="mr-1"
                      style="max-width: 200px;">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dates" @input="dates.length == 1 ? menuFecha = true : menuFecha = false"
                    @change="listar()" range>
                  </v-date-picker>
                </v-menu>
                <v-spacer />

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text fab x-small color="success" @click="crearXLSX()" :loading="desabilitar"
                      :disabled="desabilitar || !isValid" v-bind="attrs" v-on="on">
                      <v-icon>summarize</v-icon>
                    </v-btn>
                  </template>
                  <span>Reporte Excel</span>
                </v-tooltip>

                <!-- Fin Formulario Busqueda de venta usuario-->
              </v-toolbar>
            </v-form>
          </template>
          <!-- Formatear detalle -->
          <template v-slot:item.codbien="{ item }">
            <template v-if='item.codbien.length == 12'>
              <v-chip small label color="primary">
                <span style="padding: 0; margin: 0;">
                  {{ item.codbien.substr(0, 8) }}<strong>{{ item.codbien.substr(8, 12) }}</strong>
                </span>
              </v-chip>
            </template>
            <template v-else-if="item.codbien.length == 8">
              <v-chip small label color="internal" text-color="white">
                <span>{{ item.codbienint + "-" + item.codinterno }}</span>
              </v-chip>
            </template>
          </template>

          <template v-slot:item.fec_act="{ item }">
            <span>{{ item.fec_act | formatearFecha }}</span>
          </template>
          <!-- Fin Formatear detalle -->
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex"; //Importamos para llamar a los elementos
import moment from "moment";
import ExcelJS from 'exceljs';

export default {
  data() {
    return {
      reporteUsuario: [],
      dialog: false,

      encabezadoAdminSuper: [
        { text: "C. Patrimonial", value: "codbien", sortable: false, width: 135 },
        { text: "C/Int.", value: "codinterno", sortable: false },
        { text: "Tipo Bien", value: "tbdescripcion", sortable: false },
        { text: "Local", value: "nomlocales", sortable: false },
        { text: "Area", value: "nomareas", sortable: false },
        { text: "Oficina", value: "nomoficinas", sortable: false },
        { text: "Personal", value: "pnombres", sortable: false },
        { text: "FEC. ACTUALIZADO", value: "fec_act", sortable: false },
      ],
      buscar_usuario: "",
      usuarios: [],

      dates: [
        moment().startOf("day").format("YYYY-MM-DD"),
        moment().endOf("day").format("YYYY-MM-DD"),
      ],
      menuFecha: false,

      desabilitarBuscar: true,
      desabilitar: false,
      isValid: true,
      loading: false,
      alerta: { snackbar: false, color: "", text: "" },

      idempresa: "",
    };
  },

  computed: {
    ...mapState(["usuarioState", "empresaState"]), // Llamamos a state

    dateRangeText() {
      let fechaIni;
      let fechaFin;
      for (var i = 0; i < this.dates.length; i++) {
        fechaIni = this.formatFecha(this.dates[0]);
        fechaFin = this.formatFecha(this.dates[1]);
      }
      let arrayFechas = [fechaIni, fechaFin];
      return arrayFechas.join(" ~ ");
    },
  },

  created() {
    this.idusuario = parseInt(this.usuarioState.idusuario);
    this.idempresa = parseInt(this.usuarioState.idempresa);
    this.selectUsuario(parseInt(this.usuarioState.idusuario));
    this.listar();
  },

  methods: {
    formatFecha(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    /* Listar venta usuario */

    listar() {
      let me = this;
      me.desabilitar = true;
      me.loading = true;

      axios
        .get("api/Bienes/ReporteBienUsuario", {
          params: {
            idempresa: parseInt(me.idempresa),
            idusuario: parseInt(me.idusuario),
            fechaInicio: me.dates[0],
            fechaFin: me.dates[1] + " 23:59:59",
          },
        })
        .then(function (response) {
          me.reporteUsuario = response.data;
          me.desabilitar = false;
          me.loading = false;
          //console.log(me.reporteUsuario);
        })
        .catch((err) => {
          me.desabilitar = false;
          me.loading = false;
          me.alerta.snackbar = true;
          me.alerta.color = "error";
          me.alerta.text = "Ocurrio un error";
          //console.log(err.response);
        });
    },
    /* Fin Listar venta usuario */

    // Seleccionar usuario por busqueda
    selectUsuario(id) {
      let me = this;
      var usuariosArray = [];

      // Habilitamos buscar usuario por nombre para Administrador y Supervisor  !desabilitarBuscar
      if (this.usuarioState.rol == "Verificador") {
        me.desabilitarBuscar = false;
      }

      let url = "";
      if (id) {
        url = "api/Usuarios/SelectUsuario/" + id;
      } else {
        url = "api/Usuarios/SelectUsuarioFiltro?buscar=" + (me.buscar_usuario == "" ? "-" : me.buscar_usuario);
      }

      axios.get(url)
        .then(function (response) {
          usuariosArray = response.data;
          usuariosArray.map(function (x) {
            me.usuarios.push({
              text: x.nombres + " " + x.apellidos,
              value: x.idusuario,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    /* Crear excel */
    async crearXLSX() {
      // Estilo para el título principal
      const titleStyle = {
        font: { name: 'Calibri', size: 16, bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }
      };

      // Estilo para las cabeceras de la tabla de depreciación
      const tableHeaderStyle = {
        font: { name: 'Calibri', bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC6E0B4' } }, // Color verde claro
      };

      // 1. Crear un nuevo libro y una hoja de cálculo
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Reporte Usuario');

      // Crear una imagen de base64
      const Base64 = 'data:image/png;base64,' + this.empresaState.logo;
      const logoImage = workbook.addImage({
        base64: Base64,
        extension: 'jpeg',
      });

      // Agregar la imagen a la hoja de cálculo
      worksheet.addImage(logoImage, {
        ext: { width: 50, height: 65 },
      });

      // 2. Definir el ancho de las columnas para que se ajusten al contenido
      worksheet.getColumn('A').width = 6;
      worksheet.getColumn('B').width = 15;
      worksheet.getColumn('C').width = 50;
      worksheet.getColumn('D').width = 35;
      worksheet.getColumn('E').width = 35;
      worksheet.getColumn('F').width = 30;
      worksheet.getColumn('G').width = 18;
      worksheet.getColumn('H').width = 15;
      worksheet.getColumn('I').width = 10;
      worksheet.getColumn('J').width = 10;
      worksheet.getColumn('K').width = 20;
      worksheet.getColumn('L').width = 10;
      worksheet.getColumn('M').width = 20;
      worksheet.getColumn('N').width = 20;
      worksheet.getColumn('O').width = 6;
      worksheet.getColumn('P').width = 6;
      worksheet.getColumn('Q').width = 15;
      worksheet.getColumn('R').width = 8;
      worksheet.getColumn('S').width = 12;
      worksheet.getColumn('T').width = 12;
      worksheet.getColumn('U').width = 12;
      worksheet.getColumn('V').width = 12;
      worksheet.getColumn('W').width = 10;
      worksheet.getColumn('X').width = 12;
      worksheet.getColumn('Y').width = 13;
      worksheet.getColumn('Z').width = 20;
      worksheet.getColumn('AA').width = 25;
      worksheet.getColumn('AB').width = 15;
      worksheet.getColumn('AC').width = 25;
      worksheet.getColumn('AD').width = 15;
      worksheet.getColumn('AE').width = 15;
      worksheet.getColumn('AF').width = 20;
      worksheet.getColumn('AG').width = 20;
      worksheet.getColumn('AH').width = 10;
      worksheet.getColumn('AI').width = 10;
      worksheet.getColumn('AJ').width = 10;
      worksheet.getColumn('AK').width = 15;
      worksheet.getColumn('AL').width = 15;
      worksheet.getColumn('AM').width = 12;
      worksheet.getColumn('AN').width = 8;

      // 2. Añadir el título principal y combinar celdas
      worksheet.addRow(['REPORTE DE BIENES ACTIVOS - AVANCE POR USUARIO \n FECHA ' + this.dateRangeText]);
      worksheet.mergeCells('A1:AN1');
      worksheet.getCell('A1').style = titleStyle;
      worksheet.getRow(1).height = 60;

      // 3. Añadir un espacio y la cabecera de la tabla
      const headerRow = worksheet.addRow(['ITEM', 'CÓDIGO PATRIMONIAL', 'DESCRIPCIÓN', 'LOCALES', 'AREAS', 'PERSONAL', 'MARCA', 'MODELO', 'TIPO', 'COLOR', 'SERIE', 'DIMENSIÓN', 'MOTOR', 'CHASIS', 'PLACA', 'AÑO', 'CARROCERIA', 'NRO EJES', 'COMBUSTIBLE', 'TRANSMISIÓN', 'CILINDRADA', 'KILOMETRAJE', 'TARJETA PROPIEDAD', 'ASEGURADO', 'FECHA REGISTRO', 'DOCUMENTO ALTA', 'TIPO CUENTA', 'CUENTA', 'DETALLE CUENTA', 'VALOR ADQUISICIÓN', 'VALOR NETO', 'OTRAS CARACTERISTICAS', 'OBSERVACIÓN', 'SITUACIÓN', 'CONDICIÓN', 'ESTADO', 'FECHA ACTUALIZADO', 'USUARIO', 'SEGUIMIENTO', 'CÓDIGO INTERNO']);
      headerRow.eachCell(cell => {
        headerRow.eachCell((cell, colNumber) => {
          cell.style = {
            ...tableHeaderStyle,
            fill: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {
                argb: 'FFC6E0B4' // Verde claro
              }
            }
          };
        });
      });

      // 4. Añadir los datos de la tabla
      let itemCounter = 1;

      this.reporteUsuario.forEach(rowData => {
        var t_cta = "";
        var f_condicion = "";
        var f_estado = "";
        var f_situacion = "";

        for (var t = 0; t < this.cm.tipo_ctas.length; t++) {
          t_cta = t_cta + (rowData.tipo_cta == this.cm.tipo_ctas[t].value ? this.cm.tipo_ctas[t].text : "");
        }

        for (var c = 0; c < this.cm.flg_conds.length; c++) {
          f_condicion = f_condicion + (rowData.flg_cond == this.cm.flg_conds[c].value ? this.cm.flg_conds[c].text : "");
        }

        for (var e = 0; e < this.cm.flg_estados.length; e++) {
          f_estado = f_estado + (rowData.flg_estado == this.cm.flg_estados[e].value ? this.cm.flg_estados[e].text : "");
        }

        for (var e = 0; e < this.cm.flg_situaciones.length; e++) {
          f_situacion = f_situacion + (rowData.situacion == this.cm.flg_situaciones[e].value ? this.cm.flg_situaciones[e].text : "");
        }
        const row = worksheet.addRow([
          itemCounter++,
          rowData.codbien.length == '12' ? rowData.codbien : rowData.codbienint + '-' + rowData.codinterno,
          rowData.tbdescripcion,
          rowData.nomlocales,
          rowData.nomareas,
          rowData.pnombres,
          rowData.marca,
          rowData.modelo,
          rowData.tipo,
          rowData.color,
          rowData.serie,
          rowData.dimension,
          rowData.nummotor,
          rowData.numchasis,
          rowData.placa,
          rowData.ano,
          rowData.carroceria,
          rowData.nro_ejes,
          rowData.combustible,
          rowData.transmision,
          rowData.cilindrada,
          rowData.kilometraje,
          rowData.tarjeta_propiedad,
          rowData.asegurado == 'S' ? 'SI' : 'NO',
          moment(rowData.fec_reg).format('DD/MM/YYYY'),
          rowData.doc_alta,
          'USO ' + this.usuarioState.tipoempresa + ' - ' + t_cta,
          rowData.cuenta,
          rowData.cdenominacion,
          rowData.valordq,
          rowData.valorlibro,
          rowData.otras_caract,
          rowData.observacion,
          f_situacion,
          f_condicion,
          f_estado,
          moment(rowData.fec_act).format('DD/MM/YYYY HH:mm'),
          rowData.nickname,
          rowData.seguimiento ? 'Verificado' : 'No verificado',
          rowData.codinterno
        ]);

        // Aplicar estilos y bordes
        function aplicarBorde(row, startCol, endCol, colorARGB) {
          for (let col = startCol; col <= endCol; col++) {
            const cell = row.getCell(col);
            cell.border = {
              top: { style: 'thin', color: { argb: colorARGB } },
              left: { style: 'thin', color: { argb: colorARGB } },
              bottom: { style: 'thin', color: { argb: colorARGB } },
              right: { style: 'thin', color: { argb: colorARGB } },
            };
          }
        }
        aplicarBorde(row, 1, 40, 'FFC6E0B4');    // Bordes verde claro en columnas 1 a mas

        // Centrar la celda
        [1, 2, 24, 25, 34].forEach(col => {
          row.getCell(col).alignment = { horizontal: 'center' };
        });

        // Formato y estilo para columnas
        [30, 31].forEach(col => {
          const cell = row.getCell(col);
          cell.numFmt = '#,##0.00'; // incluye símbolo de soles
          cell.alignment = { horizontal: 'right' };
          cell.font = { name: 'Calibri', size: 11 };
        });
      });

      // Ocultar las líneas de división de la hoja de cálculo
      worksheet.views = [
        {
          showGridLines: false
        }
      ];

      // 7. Generar el archivo y descargarlo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Reporte Usuario.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    /* Fin Crear excel stock */
  },
};
</script>
